import { Component } from '@angular/core';
import { soundpostDimensionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Dimensions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostdimension-form',
    templateUrl: './soundpostdimension.form.component.html'
})
export class soundpostDimensionFormComponent extends BaseFormComponent {
    public record!: soundpostDimensionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'accountingEntryLineDimensions', sectionName: 'Accounting Entry Line Dimensions', isExpanded: false },
            { sectionKey: 'postingGroupLineDimensions', sectionName: 'Posting Group Line Dimensions', isExpanded: false },
            { sectionKey: 'productGLAccountDimensions', sectionName: 'Product GL Account Dimensions', isExpanded: false }
        ]);
    }
}

